import { Injectable } from '@angular/core';
import { ConfigService } from '../config/config.service';
import { HttpClient } from '@angular/common/http';
import { Observable, lastValueFrom } from 'rxjs';
import { LoaderService } from '../loader/loader.service';
import { MenuItem } from '@app/shared/interfaces/menu/menu.model';

@Injectable({
  providedIn: 'root'
})
export class MenuService {

  private menu: MenuItem[] = []

  constructor(private http: HttpClient, private cs: ConfigService, private loaderSvc: LoaderService,) { }

  /**
    * Realiza el proceso de traer el menu del usuario.
    *   - Obtiene el menú del usuario autenticado.
    * @param idUser id del usuario a consultar su menu
    * @returns {Observable<any>} Respuesta del servidor con el estado del login y los datos recibidos.
    */
  getMenuByUserConsult(): Observable<any> {
    return this.http.get(`${this.cs.urlEnviroment}api/login/getMenu/user`)
  }

  setMenu(newMenu: MenuItem[]) {
    this.menu = newMenu
  }

  deleteMenu(): void {
    this.menu = []
  }

  getMenu(): MenuItem[] {
    return this.menu;
  }



  async getAsyncMenuByUser(): Promise<MenuItem[]> {
    try {
      if (!this.menu.length) {
        this.loaderSvc.show()
        this.loaderSvc.text.set({ text: 'Cargando tipos de documento' })
        let m = await lastValueFrom(this.getMenuByUserConsult());
        this.loaderSvc.hide()

        if (m.ok) {
          const menuData = m.data;
          if (menuData && menuData.length > 0) {
            // Si hay exactamente 4 elementos, intercambiamos la posición 3 y 4 (índices 2 y 3)
            if (menuData.length === 5 && menuData[4].name === 'Interoperabilidad') {
              const temp = menuData[3];
              menuData[3] = menuData[4];
              menuData[4] = temp;
            }

            this.setMenu(m.data)
          } else {
            this.deleteMenu();
          }
        }
      }
      return this.menu;
    } catch (error) {
      this.loaderSvc.hide()
      this.deleteMenu();
      return this.menu;
    }

  }

}
